import Tooltip from '@mui/material/Tooltip'
import { useEffect, useState } from 'react';
import Map, {Source, Layer,Marker  } from 'react-map-gl';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import VideocamIcon from '@mui/icons-material/Videocam';
import {colors} from '../utils/colorDict'
import NewspaperIcon from '../assets/newspaper.png'

const MapMarker =({i, item,handleModalData,coords})=>{

const [hoveredMarker,setHoveredMarker] = useState(null)
  const [loaded,setLoaded] = useState(false)
  return <Marker 
    key={i} 
    longitude={coords[0]} 
    latitude={coords[1]} 
    anchor="bottom" 
  style={{
    zIndex:1
    
  }}
     onClick={()=>{
      
      handleModalData(item,item.properties.mediatype)
    }}
     >
     <Tooltip title={item.properties?.title || 'item'}> 
<div 
   onMouseEnter={()=>{
    setHoveredMarker(i)
  }}
  onMouseLeave={()=>{
    setHoveredMarker(null)
  }}
      style={{cursor:'pointer',
      opacity:1,
      backgroundColor:colors[item.properties.mediatype],
      borderRadius:'10px',
      padding:'1px',
      transition:'0.1s',
      width: i===hoveredMarker ? '8px' :'8px',
      height:i===hoveredMarker ? '8px' :'8px',
}}>
{/* 
 <img
 style={{
   transition:'0.1s',
  width: i===hoveredMarker ? '28px' :'25px',
  height:i===hoveredMarker ? '28px' :'25px',
 imageFit:'stretch',
borderRadius:'10px',
display:loaded? "block" : 'none',

}} 
onLoad={()=>{
  setLoaded(true)
}}
onError={()=>{
  setLoaded(false)
}}
     src={
      item.properties.mediatype===1 ?
    item?.properties.image_url :
      item.properties.mediatype===2 ? 
      NewspaperIcon: 
    item.properties.mediatype===3 ?
    "https://img.youtube.com/vi/"+item.id+"/0.jpg"
    : null
  }
 >
 </img>  */}
 
 {/* {
item.properties.mediatype===1  ?

:
item.properties.mediatype===3 ?
<VideocamIcon  sx={{color:'whitesmoke',display:!loaded ? "block" : 'none',
   transition:'0.1s',
width: i===hoveredMarker ? '28px' :'25px',
height:i===hoveredMarker ? '28px' :'25px',}}/> : null 
} */}
</div>
  </Tooltip>

 
 </Marker>
}

export default MapMarker